module.exports = __webpack_public_path__ + "media/images/front/materiales_sup-128dc6d7e2b3df0e235ab0a24319ddde.png";